import React, { Component } from 'react';
import { Modal, Button,  } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import { processCsvIfOK, hideUploadCsvModal, showCsvResultsModal } from '../../actions';

const dropzoneStyle = {
    width: '100%',
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
};

class UploadCsvModal extends Component {
    constructor(props) {
        super(props);

        this.onDrop = this.onDrop.bind(this);
    }

    onDrop(files) {
        const {processCsvIfOK, hideUploadCsvModal, showCsvResultsModal} = this.props;

        var file = files[0];
        // Windows (sometimes) uploads .csv files with an excel mimetype. Why? No idea. But its dumb.
        // This does mean an excel sheet (or anything) named .csv will break things... /shrug
        if(file && file.name.endsWith('.csv') && (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel')) {
            hideUploadCsvModal();
            showCsvResultsModal();
            processCsvIfOK(files[0]);
        }
    }

    render() {
        const {show, hideUploadCsvModal} = this.props;

        let dropzone;

        return (
            <Modal show={show} onHide={hideUploadCsvModal}>
                <Modal.Header closeButton>
                    <Modal.Title> Upload CSV </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropzone ref={(node) => { dropzone = node; }} onDrop={this.onDrop} multiple={false} style={dropzoneStyle}>
                        <div className='text-center'>
                            <span className='btn-lg glyphicon glyphicon-upload'/>
                            <p>Drop CSV here</p>
                        </div>
                    </Dropzone>
                    <hr/>
                    <Button block type="button" onClick={() => { dropzone.open(); }}>
                        Browse
                    </Button>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = state =>({
    show: state.ui.uploadCsv.show
});

const mapDispatchToProps = {
    hideUploadCsvModal,
    processCsvIfOK,
    showCsvResultsModal
};

UploadCsvModal.propTypes = {
    show:                PropTypes.bool.isRequired,
    hideUploadCsvModal:  PropTypes.func.isRequired,
    processCsvIfOK:      PropTypes.func.isRequired,
    showCsvResultsModal: PropTypes.func.isRequired
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadCsvModal);



// WEBPACK FOOTER //
// ./src/components/csv/UploadCsvModal.js